import global from '@/mixins/shared/global'
import Repository from './Repository'
const serverNotificationRepo = Repository(global.basePath)
const serverNotificationRepoSkipLoading = Repository(global.basePath, true)

const resource = '/ServerNotification'

export default {
  create (payload) {
    return serverNotificationRepo.post(`${resource}`, payload)
  },

  getActive (payload) {
    return serverNotificationRepoSkipLoading.get(`${resource}/active`, payload)
  },

  getAll (payload) {
    return serverNotificationRepo.get(`${resource}`, payload)
  },

  update (payload) {
    return serverNotificationRepo.put(`${resource}`, payload)
  },

  delete (payload) {
    return serverNotificationRepo.post(`${resource}/delete`, payload)
  }
}
